import React, { Component, useState, useEffect, useRef } from 'react';
import {
  useNavigate,
  Link
} from 'react-router-dom';
import { withTranslation, Translation, } from 'react-i18next';
import i18n from "../../../i18n";

import { fullCountries } from '../../../utils';

import Select from 'react-select';

import { TextInput, Image, View, Text, ActivityIndicator} from "react-native-web";

import HamburgerMenu from 'react-hamburger-menu';

import { Gradient } from 'react-gradient';

import Hls from 'hls.js';

import {BrowserView,MobileView,TabletView, isMobileOnly, isTablet} from 'react-device-detect';


import { ParallaxProvider, ParallaxBanner, Parallax } from 'react-scroll-parallax';
import { AnimatePresence, motion, useScroll, useTransform, useMotionValue } from 'framer-motion';


import AutoResizeText from './AutoResizeText';

import MyLoadingComponent from './MyLoadingComponent';

import HeaderMobile from "../../header/HeaderMobile";

import { Document, Page } from 'react-pdf';

import { pdfjs } from 'react-pdf';

pdfjs.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url,
).toString();

const algoliasearch = require('algoliasearch');
var client = algoliasearch('HKB157K3KU', '357f2b37e5ef8c12f7b90877758ff663');

const viewportWidth = window.innerWidth;
const viewportHeight = window.innerHeight;

const words = ['Refonder', 'Réinventer', 'Réinitialiser', 'Reconstruire', 'Rebâtir', 'Réformer', 'Réorganiser', 'Réécrire', 'Réenraciner',  'Revitaliser', 'Réveiller', 'Réanimer', 'Ressusciter', 'Régénérer', 'Redéfinir', 'Réclamer', 'Revaloriser', 'Réhabiliter', 'Réconcilier'];



const contributionOptions = [{value: 'Time', label: 'Du temps (disponibilité régulière ou ponctuelle)'}, {value: 'Expertise', label: 'Mon expertise professionnelle'}, {value: 'Idea', label: 'Mes idées / réflexions stratégiques'},
                             {value: 'Communication_skills', label: 'Mes compétences en communication / médias'}, {value: 'IT_skills', label: 'Mes compétences techniques (web, IT, etc.)'}, {value: 'Field_experience', label: 'Mon expérience terrain / communautaire'},
                             {value: 'Network', label: 'Mon réseau (personnes, structures, partenaires…)'}, {value: 'Logistics', label: 'Un espace physique ou logistique (salle, matériel...)'}, {value: 'Leadership', label: 'Ma capacité d’écoute et de mobilisation'},
                             {value: 'Organization_skills', label: 'Mes compétences en organisation d’événements'}, {value: 'Energy', label: 'Mon énergie et ma motivation'}, {value: 'Dont_know', label: 'Je ne sais pas encore, mais je veux contribuer'},
                           ];
const organizationContributionOptions = [{value: 'Time', label: 'Du temps (disponibilité régulière ou ponctuelle)'}, {value: 'Expertise', label: 'Notre expertise professionnelle'}, {value: 'Idea', label: 'Nos idées / réflexions stratégiques'},
                             {value: 'Communication_skills', label: 'Nos compétences en communication / médias'}, {value: 'IT_skills', label: 'Nos compétences techniques (web, IT, etc.)'}, {value: 'Field_experience', label: 'Notre expérience terrain / communautaire'},
                             {value: 'Network', label: 'Notre réseau (personnes, structures, partenaires…)'}, {value: 'Logistics', label: 'Un espace physique ou logistique (salle, matériel...)'}, {value: 'Leadership', label: 'Notre capacité d’écoute et de mobilisation'},
                             {value: 'Organization_skills', label: 'Nos compétences en organisation d’événements'}, {value: 'Energy', label: 'Notre énergie et notre motivation'}, {value: 'Dont_know', label: 'Nous ne savons pas encore, mais nous voulons contribuer'},
                           ];



let titleFontSize30, titleFontSize25, titleFontSize22, titleFontSize20, titleFontSize19, titleFontSize18, titleFontSize17, titleFontSize16, titleFontSize15, titleFontSize13, titleFontSize;

if (viewportWidth > 1400)
{
  titleFontSize = 40;
  titleFontSize30 = 30;
  titleFontSize25 = 25;
  titleFontSize22 = 22;
  titleFontSize20 = 20;
  titleFontSize19 = 19;
  titleFontSize18 = 18;
  titleFontSize17 = 17;
  titleFontSize16 = 16;
  titleFontSize15 = 15;
  titleFontSize13 = 13;
}
else if (viewportWidth > 1200)
{
  titleFontSize = 35;
  titleFontSize30 = 26;
  titleFontSize25 = 22;
  titleFontSize22 = 20;
  titleFontSize20 = 19;
  titleFontSize19 = 18;
  titleFontSize18 = 17;
  titleFontSize17 = 16;
  titleFontSize16 = 15;
  titleFontSize15 = 14;
  titleFontSize13 = 12;
}
else
{
  titleFontSize = 30;
  titleFontSize30 = 24;
  titleFontSize25 = 19;
  titleFontSize22 = 17;
  titleFontSize20 = 18;
  titleFontSize19 = 17;
  titleFontSize18 = 16;
  titleFontSize17 = 15;
  titleFontSize16 = 14;
  titleFontSize15 = 13;
  titleFontSize13 = 11;
}

function generatePassword(length) {
   const charset = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
   let password = '';
   for (let i = 0; i < length; i++) {
       const randomIndex = Math.floor(Math.random() * charset.length);
       password += charset[randomIndex];
   }
   return password;
}

function formatPhoneNumber(number) {
 // Nettoyer les espaces et caractères spéciaux
let cleaned = number.replace(/[\s-]/g, '');

// Extraire le numéro local sans indicatif
let local;

if (/^(\+|00|0)243/.test(cleaned)) {
  local = cleaned.replace(/^(\+|00|0)243/, '');
} else if (/^0/.test(cleaned)) {
  local = cleaned.substring(1);
} else if (/^\+/.test(cleaned)) {
  // Si c'est un numéro étranger, on laisse le numéro tel quel (optionnel)
  return cleaned;
} else {
  local = cleaned;
}

// Garder seulement les 3 derniers chiffres
const last3 = local.slice(-3);

return `+243 --- --- ${last3}`;
}

function parseCo(items) {
 const names = items.map(item => item.sigle  && item.sigle !== '' ? item.sigle : item.name);

 const result = formatList(names);

 return result;
}

function formatList(list) {
 if (list.length === 0) return '';
 if (list.length === 1) return list[0];
 if (list.length === 2) return `${list[0]} et ${list[1]}`;
 return `${list.slice(0, -1).join(', ')} et ${list[list.length - 1]}`;
}

function convertDate(dateISO, lang) {
 const date = new Date(dateISO);

 let lg;
 if (lang === 'fr')
 {
    lg = 'fr-FR';
 }
 else
 {
    lg = 'en-US';
 }

 const formatted = new Intl.DateTimeFormat(lg, {
   weekday: 'short',  // jour de la semaine
   year: 'numeric',
   month: 'long',
   day: 'numeric'
 }).format(date);
 return formatted;
}

function capitalizeFirstLetter(text) {
 if (!text) return ''; // sécurité si texte vide ou null
 return text.charAt(0).toUpperCase() + text.slice(1);
}


class OpenDiscoverMyRoleMobile extends Component {

  constructor(props) {

        super(props);

        this.formDivRef = React.createRef();
        this.formContainerRef = React.createRef();

        this.inputs = [];



     this.state = {
       current_user: null,
       arr: [],
       code: ["", "", "", ""],
       password: '',
       typeCP: 'password',
       step: 1,
       errorStatus: '',
       contributions: [],
       contributionOptions: contributionOptions,
       organizationContributionOptions: organizationContributionOptions,
       countryOptions: [],
       selectedCountryOption: null,
       regionOptions: [],
       selectedRegionOption: {value: 'CD-KN', label: 'Kinshasa'},
       firstName: '',
       lastName: '',
       email: '',
       phone: '',
       region: '',
       role: '',
       infos: '',
       companyName: '',
       selectedSizeOption: null,
       sizeOptions: [{label: '1-10', value: '1-10'}, {label: '11-50', value: '11-50'}, {label: '51-100', value: '51-100'}, {label: '101-500', value: '101-500'}, {label: '501-1000', value: '501-1000'}, {label: '>1000', value: '>1000'}],
       editProfileStep: 1,
       profileCateg: null,
       processing: false,
       status: 'init',
       currentYear: new Date().getFullYear()
     };

   }


  componentDidMount(){
       window.addEventListener('resize', this.handleResize);
      this.handleResize(); // initialize on mount
      this.loadCountries();
      this.loadRegions();



    /*  var ip = 'https://api2.debyoo.com/'; //generateIPForREST();


      fetch(ip+'delete_rerdc_sr_api', {
                              method: 'POST',
                              headers: {
                                'Accept': 'application/json',
                                'Content-Type': 'application/json'
                              },
                              body: JSON.stringify({
                                id: '685196b7e3d16c4acde4cf0c'
                              })
         })
       .then((response) => response.json())
       .then((responseData) => {
           console.log('>> delete_rerdc_sr_api >> ' + JSON.stringify(responseData));

       })
        .catch(function(error) {

        }.bind(this)); */



  }

  componentWillMount(){

  }

 componentWillUnmount(){
    window.removeEventListener('resize', this.handleResize);

  }

  loadRegions() {
        var index = client.initIndex('Regionname');


        index
        .search('*',
        {
          page: 0,
          filters: `country:CD`
        })
        .then(({ hits, nbPages, page, nbHits }) =>
        {

              if (nbHits > 0)
              {
                const transformedArray = hits.map(item => ({
                  value: item.iso_state_code,
                  label: item.name
                }));

                this.setState({
                  regionOptions: transformedArray
                })
              }
         });
  }


  loadCountries() {
       var _countries = [], _countryOptions = [];

        for (let i = 0; i < fullCountries().length; i++)
        {
              let c = fullCountries()[i];

              if (i18n.language == "fr")
              {
                    if (c.official_name_fr !== "")
                    {
                        var _obj = {
                          value: c.iso_2, label: c.official_name_fr
                        };

                        _countries.push(_obj);
                    }
              }
              else if (i18n.language == "en")
              {
                  if (c.official_name_en !== "")
                  {
                      var _obj = {
                        value: c.iso_2, label: c.official_name_en
                      };

                      _countries.push(_obj);
                  }
              }

              if (i == fullCountries().length-1)
              {

                      _countryOptions = _countries.sort((a,b) => a.label.localeCompare(b.label));

                      var _elemIndex = _countryOptions.findIndex(obj => obj.value == global.country);



                     if (_elemIndex > -1)
                     {

                            this.setState({
                              countryOptions: _countryOptions,
                              selectedCountryOption: _countryOptions[_elemIndex]
                            });
                     }
                     else
                     {
                           this.setState({
                             countryOptions: _countryOptions
                           });
                     }

              }
        }
  }






  handleResize = () => {




    let vw;
    if (window.innerWidth > 1400)
    {
      vw = 1230;
    }
    else if (window.innerWidth > 1200)
    {
      vw = 1030;
    }
    else
    {
      vw = 900;
    }

    const videoWidth = vw;

    //console.log('Resiez :: videoWidth >>> ' + videoWidth)

    this.setState({
      videoWidth: videoWidth,
      viewportWidth: window.innerWidth,
      viewportHeight: window.innerHeight,
    });
  }


    goToStepTwo() {
      this.formContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.setState({
        editProfileStep: 2
      });
    }

    backToStepOne() {
      this.formContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      this.setState({
        editProfileStep: 1,
        profileType: null
      })
    }


    cancelFormFilling() {
      this.backToStepOne();
      this.props.quitDiscoverMyRole();
    }


    submitForm() {


            if (this.state.profileType === 'Organization')
            {
                       if (this.state.firstName.length === 0 || this.state.lastName.length === 0 || companyName.length === 0 || companySector.length === 0 ||
                               contactRole.length === 0 || selectedSizeOption === null)
                       {
                             this.scrollToRef();

                             this.setState({
                               status: 'error'
                             });
                       }
                       else if (!this.isEmail(this.state.email))
                       {
                             this.setState({
                               status: 'emailerror'
                             });
                             this.scrollToRef();
                      }
                      else if (this.state.phone.length === 0)
                      {
                            this.setState({
                              status: 'error'
                            });
                            this.scrollToRef();
                      }
                      else
                      {
                            this.setState({
                              processing: true
                            });
                            this.sendHTTPRequest();

                      }
            }
            else
            {

                    if (this.state.firstName.length === 0 || this.state.lastName.length === 0 )
                     {
                         this.scrollToRef();

                         this.setState({
                           status: 'error'
                         });
                     }
                     else if (!this.isEmail(this.state.email))
                     {

                         this.setState({
                           status: 'emailerror'
                         });
                         this.scrollToRef();
                    }
                    else if (this.state.phone.length === 0)
                    {
                        this.setState({
                          status: 'error'
                        });
                        this.scrollToRef();
                    }
                    else
                    {
                        this.setState({
                          processing: true
                        });
                        this.sendHTTPRequest();
                    }

          }


    }


    sendHTTPRequest() {

               var ip = 'https://api0.debyoo.com/'; // generateIPForREST();

               let region = this.state.region;
               if (this.state.selectedCountryOption.value === 'CD')
               {
                  region = this.state.selectedRegionOption.value;
               }

               let organization_size = '';
               if (this.state.profileCateg === 'Organization' && this.state.selectedSizeOption !== null)
               {
                  organization_size = this.state.selectedSizeOption.value;
               }

               //const contributions = this.state.contributions.map(item => item.value);



               let hash = {
                 request_type: 'creatifs',
                 product_name: 'mvc',
                 product_target: this.state.profileCateg,
                 channel: 'www.re-rdc.com',
                 platform: 'web',
                 user_agent: navigator.userAgent,
                 profile_categ: this.state.profileCateg,
                 first_name: this.state.firstName,
                 last_name: this.state.lastName,
                 role: this.state.role,
                 email: this.state.email,
                 phone: this.state.phone,
                 phone_country_code: '243',
                 country: this.state.selectedCountryOption.value || '',
                 region: region,
                 contributions: '',
                 infos: this.state.infos,
                 organization_name: this.state.companyName,
                 organization_size: organization_size,
                 lang: i18n.language
               };


               //alert(JSON.stringify(contributions));



               fetch(ip+'submit_rerdc_applic_form_api', {
                      method: 'POST',
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify(hash)
                   })
                 .then((response) => response.json())
                 .then((responseData) => {

                       if (responseData.status === 'success')
                       {
                               this.formContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                               window.scrollTo(0,0);
                               this.setState({
                                 processing: false,
                                 editProfileStep: 3,
                               });

                               this.createContactpeople(responseData.id);
                               this.sendBONotif(responseData.id);


                               setTimeout(() => {
                                 this.cancelFormFilling()
                               }, 15000);

                        }
                        else
                        {
                              this.formContainerRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
                              window.scrollTo(0,0);
                              this.setState({
                                processing: false,
                                editProfileStep: 4,
                              });

                              setTimeout(() => {
                                this.cancelFormFilling()
                              }, 12000);
                        }



                 })
                  .catch(function(error) {

                  }.bind(this));


    }



    createContactpeople = (id) => {


        var ip = 'https://api1.debyoo.com/'; // generateIPForREST();


        fetch(ip+'add_new_contactpeople_from_request_api', {
               method: 'POST',
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               },
               body: JSON.stringify({
                 creation_mode: 'creativerequest',
                 app: 'RERDC',
                 id: id,
                 product_name: 'mvc',
                 product_target: this.state.profileCateg,
                 first_name: this.state.firstName,
                 last_name: this.state.lastName,
                 email: this.state.email,
                 organization_id: '',
                 organization_name: this.state.companyName,
                 contact_role: this.state.role,
                 country: this.state.selectedCountryOption.value,
                 phone: this.state.phone,
                 label: '',
                 visibility: ''
               })
            })
          .then((response) => response.json())
          .then((responseData) => {



          })
           .catch(function(error) {

           }.bind(this));

     }


    sendBONotif = (id) => {

             var ip = 'https://api2.debyoo.com/'; //generateIPForREST();


             fetch(ip+'send_notif_join_creative_request_api', {
                                     method: 'POST',
                                     headers: {
                                       'Accept': 'application/json',
                                       'Content-Type': 'application/json'
                                     },
                                     body: JSON.stringify({
                                       id: id
                                     })
                })
              .then((response) => response.json())
              .then((responseData) => {
                  console.log('>> send_notif_join_creative_request_api >> ' + JSON.stringify(responseData));

              })
               .catch(function(error) {

               }.bind(this));

    }



    get authSubmit() {
      let bool = true;

      if (this.state.firstName.length === 0 || this.state.lastName.length === 0 || this.state.email.length === 0 || !this.isEmail(this.state.email) ||
          this.state.phone.length === 0 || this.state.role.length === 0 || this.state.selectedCountryOption === null)
      {
         bool = false;

      }

      if (this.state.profileCateg === 'Organization' && (this.state.companyName.length === 0 || this.state.selectedSizeOption === null ))
      {
         bool = false;
      }

      if (this.state.selectedCountryOption !== null)
      {
          if (this.state.selectedCountryOption.value === 'CD' && this.state.selectedRegionOption === null)
          {
              bool = false;
          }
          else if (this.state.selectedCountryOption.value !== 'CD' && this.state.region.length === 0)
          {
              bool = false;
          }
      }

      return bool;
    }


     isEmail = (email) =>  {
          return /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(email);
     }

     isPhone = (phone) => {

         var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

         return re.test(phone);

     }

     onEmailChange = (e) => {
         this.setState({
           status: ''
         });
     }

     onPhoneChange = (e) => {
       this.setState({
         status: ''
       });
     }

     onFieldChange = (e) => {
       this.setState({
         status: ''
       });
     }

     onChangeContribution = (e, actionMeta) => {


             let array = this.state.contributions;
             if (actionMeta.action === 'select-option')
             {

                    array.push(actionMeta.option);

                    this.setState({
                      status: '',
                      contributions: array
                    });

             }
             else if (actionMeta.action === 'pop-value' || actionMeta.action === 'remove-value')
             {


                    var _elemIndex = array.findIndex(obj => obj.value == actionMeta.removedValue.value);

                   if (_elemIndex > -1)
                   {
                     array.splice(_elemIndex, 1);

                     this.setState({
                       status: '',
                       contributions: array
                     });
                   }
                   else
                   {
                     this.setState({
                       status: '',
                     });
                   }


             }
             else if (actionMeta.action === 'clear')
             {
                  this.setState({
                    status: '',
                    contributions: []
                  });
             }

     }


     scrollToRef = () => {
        this.formDivRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });

     }




     // STEP 3

     onSubmitPassword =  async (event) => {
        event.preventDefault();

        this.setState({
          processing: true
        });

        this.createPassword();

     }


     createPassword() {

           var ip = 'https://api1.debyoo.com/'; // generateIPForREST();


           let hash = {
             auth_check: 'jwt',
             password: this.state.password
           };




           fetch(ip+'change_password_new_user_beji_api', {
                  method: 'POST',
                  headers: {
                    'Accept': 'application/json',
                    'Authorization': jwtToken,
                    'Content-Type': 'application/json'
                  },
                  credentials: 'include',
                  body: JSON.stringify(hash)
               })
             .then((response) => response.json())
             .then((responseData) => {

                    if (responseData.status === 'success')
                    {

                        localStorage.setItem("bejijwtToken", this.state.current_user.jwt_token);
                        localStorage.setItem("bejiUser", JSON.stringify(this.state.current_user));

                        setTimeout(() => {
                          this.setState({
                            errorStatus: 'connecting',
                            processing: false,
                            step: 5
                          });
                        }, 1000);


                         setTimeout(() => {
                           window.location = `/e/${this.state.pid}`;
                           this.setState({
                             errorStatus: ''
                           });
                         }, 5000);

                    }
                    else
                    {

                          this.setState({
                            processing: false,
                            step: 1
                          });

                    }

             })
              .catch(function(error) {

              }.bind(this));

     }

    // STEP 2

    createUser() {



          var ip = 'https://api0.debyoo.com/';;


          let hash = {
               typef: 'ajx',
               req: 'api',
               a: 'global',
               v: 'last',
               lang: 'fr',
               participant_id: this.state.participant_id, // '67cbdba6e3d16c3dfbf32612',
               user:{
                 category: 'Personal_profile',
                 dcareer_account_type: 'Person',
                 email: this.state.email,
                 password: generatePassword(8),
               }
          };


          fetch(ip+'signupbejiuser', {
              method: 'POST',
               headers: {
                 'Accept': 'application/json',
                 'Content-Type': 'application/json'
               },
               body: JSON.stringify(hash)
              })
            .then((response) => response.json())
            .then((responseData) => {

                  //  alert(JSON.stringify(responseData))

                   if (responseData.status === 'success')
                   {

                        this.setState({
                          processing: false,
                          step: 3,
                          errorStatus: 'code_verified',
                          current_user: responseData.output,
                          code: ["", "", "", ""],
                        });


                        setTimeout(() => {
                          this.setState({
                            errorStatus: ''
                          });
                        }, 6000);



                   }
                   else if (responseData.status === 'exists')
                   {

                         localStorage.setItem("bejijwtToken", responseData.output.jwt_token);
                         localStorage.setItem("bejiUser", JSON.stringify(responseData.output));


                         this.setState({
                           processing: false,
                           errorStatus: 'code_verified',
                           current_user: responseData.output,
                           code: ["", "", "", ""],
                         });


                         setTimeout(() => {
                           this.setState({
                             errorStatus: '',
                           });
                         }, 3000);

                         setTimeout(() => {
                           this.setState({
                             errorStatus: 'connecting',
                             step: 5
                           });
                         }, 4000);


                          setTimeout(() => {
                            window.location = `/e/${this.state.pid}`;
                            this.setState({
                              errorStatus: ''
                            });
                          }, 6000);
                   }
                   else
                   {

                   }


              })
              .catch(function(error) {

              }.bind(this));



    }


     checkCode(code) {


       var ip = 'https://api0.debyoo.com/'; // generateIPForREST();


       let hash = {
         id: this.state.participant_id,
         code: code,
         phone: `243${this.state.phone}`,
         email: this.state.email
       };

       //alert(JSON.stringify(hash))




       fetch(ip+'verify_access_code_beji_api', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(hash)
           })
         .then((response) => response.json())
         .then((responseData) => {

              //  alert(JSON.stringify(responseData))


                if (responseData.status === 'success')
                {

                     if (responseData.user_exists === "no")
                     {
                          this.createUser();
                     }
                     else
                     {

                           //localStorage.setItem("bejijwtToken", responseData.user.jwt_token);
                           //localStorage.setItem("bejiUser", JSON.stringify(responseData.user));

                           this.setState({
                             processing: false,
                             step: 5,
                             errorStatus: 'connecting',
                             current_user: responseData.user,
                             code: ["", "", "", ""],
                           });



                            setTimeout(() => {
                              //window.location = `/e/${this.state.pid}`;
                              this.props.giveAccessToUser();
                              this.setState({
                                errorStatus: ''
                              });
                            }, 3000);
                     }



                }
                else if (responseData.status === 'expired')
                {

                     this.setState({
                       code: ["", "", "", ""],
                       errorStatus: 'code_expired',
                       processing: false,
                     });


                     setTimeout(() => {
                       this.setState({
                         errorStatus: ''
                       });
                     }, 6000);

                }
                else
                {

                     this.setState({
                       code: ["", "", "", ""],
                       errorStatus: 'code_incorrect',
                       processing: false,
                     });

                     setTimeout(() => {
                       this.setState({
                         errorStatus: ''
                       });
                     }, 6000);

                }


         })
          .catch(function(error) {

          }.bind(this));




     }


     resendCode() {

       this.setState({
         processing: true,
         errorStatus: ''
       });

       var ip = 'https://api0.debyoo.com/'; // generateIPForREST();


       let hash = {
         id: this.state.participant_id,
         arr: this.state.arr.join(',')
       };




       fetch(ip+'resend_access_code', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(hash)
           })
         .then((response) => response.json())
         .then((responseData) => {

            // alert(responseData.status)

                if (responseData.status === 'success')
                {

                     let errorStatus = '';
                     if (responseData.arr.indexOf('email') > -1 && responseData.arr.indexOf('phone') > -1)
                     {
                         errorStatus = 'code_both';
                     }
                     else if (responseData.arr.indexOf('email') > -1)
                     {
                         errorStatus = 'code_email';
                     }
                     else if (responseData.arr.indexOf('phone') > -1)
                     {
                        errorStatus = 'code_phone';
                     }

                     this.setState({
                       step: 2,
                       errorStatus: errorStatus,
                       processing: false,
                     });


                }


         })
          .catch(function(error) {

          }.bind(this));

     }


     // STEP 1

     onSubmit =  async (event) => {
        event.preventDefault();


        if (this.state.phone.trim() === '' || this.state.phone.length < 9 )
        {
          this.setState({
            errorStatus: 'phone'
          });

          setTimeout(() => {
            this.setState({
              errorStatus: ''
            });
          }, 3000);
        }
        else if (this.state.email.trim() === '' || !this.isEmail(this.state.email))
        {
           this.setState({
             errorStatus: 'email'
           });

           setTimeout(() => {
             this.setState({
               errorStatus: ''
             });
           }, 3000);
        }
        else
        {
          this.setState({
            processing: true
          });

          this.checkContacts();
        }



     }

     checkContacts() {
       var ip = 'https://api0.debyoo.com/'; // generateIPForREST();

       //alert(JSON.stringify(this.state.object))


       let hash = {
         channel: 'www.re-rdc.com',
         platform: 'web',
         id: '',
         user_agent: navigator.userAgent,
         email: this.state.email,
         phone: this.state.phone,
         phone_country_code: '+243',
         country: global.country,
         lang: i18n.language
       };




       fetch(ip+'check_creatives_rerdc_api', {
              method: 'POST',
              headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(hash)
           })
         .then((response) => response.json())
         .then((responseData) => {

             //alert(responseData.status)

               if (responseData.status === 'error')
               {
                      this.setState({
                        processing: false,
                        errorStatus: 'error',
                        phone: '',
                        email: ''
                      });

                      setTimeout(() => {
                        this.setState({
                          errorStatus: ''
                        });
                      }, 6000);

                }
                else if (responseData.status === 'success')
                {

                     let errorStatus = '';
                     if (responseData.arr.indexOf('email') > -1 && responseData.arr.indexOf('phone') > -1)
                     {
                         errorStatus = 'code_both';
                     }
                     else if (responseData.arr.indexOf('email') > -1)
                     {
                         errorStatus = 'code_email';
                     }
                     else if (responseData.arr.indexOf('phone') > -1)
                     {
                        errorStatus = 'code_phone';
                     }

                     this.setState({
                       editProfileStep: 2,
                       arr: responseData.arr,
                       participant_id: responseData.participant_id,
                       errorStatus: errorStatus,
                       processing: false,
                     });


                }
                else if (responseData.status === 'has_access')
                {
                      this.setState({
                        processing: false,
                        errorStatus: 'has_access',
                        phone: '',
                        email: '',
                        editProfileStep: 5
                      });

                    //  this.props.giveAccessToUser();

                }
                else if (responseData.status === 'no_request')
                {
                    this.setState({
                      processing: false,
                      errorStatus: 'no_request',
                      phone: '',
                      email: ''
                    });
                }
                else
                {

                  this.setState({
                    processing: false,
                  });
                  // alert(responseData.status);
                }

         })
          .catch(function(error) {

          }.bind(this));

     }

     handleChangePhone = event => {

        let value = event.target.value;

         // Supprime tout sauf les chiffres
         value = value.replace(/\D/g, "");

         // Rejeter si le premier caractère est 0 ou +
         if (value.startsWith("0") || event.target.value.startsWith("+")) {
           value = "";
         }

         // Limiter à 11 chiffres max
         if (value.length > 9) {
           value = value.slice(0, 9);
         }

        this.setState({
          phone: value
        });
     }


     handleChangeEmail = event => {
        this.setState({
          email: event.target.value
        });
     }

     handleChangePassword = (event) => {
       const input = event.target.value.replace(/\s/g, ""); // supprime tous les espaces
       this.setState({ password: input });
     }

     handleKeyDownPassword = (event) => {
       if (event.key === " ") event.preventDefault();
     }

     handleChange = (index, event) => {
         const value = event.target.value;
         if (!/^\d?$/.test(value)) return; // n'accepte que les chiffres ou vide

         const code = [...this.state.code];
         code[index] = value;
         this.setState({ code }, () => {
           if (value && index < 3) {
             this.inputs[index + 1].focus();
           }

           if (code.every((digit) => digit !== "")) {
             this.blurAllInputs();
             this.handleSubmit(code.join(""));
           }
         });
       };

       handleBlur = (index) => {
         if (this.state.code[index] && index < 3) {
           this.inputs[index + 1].focus();
         }
       };

       handleKeyDown = (index, event) => {
         if (event.key === "Backspace" && !this.state.code[index] && index > 0) {
           this.inputs[index - 1].focus();
         }
       };

       handleSubmit = (fullCode) => {
          this.setState({
            processing: true
          });


          setTimeout(() => {
            this.checkCode(fullCode);
          }, 1000);
      };

      blurAllInputs = () => {
         this.inputs.forEach((input) => input && input.blur());
      };


     get authToSubmit() {
        let bool = false;

        if (this.isEmail(this.state.email))
        {
           bool = true;
        }

        return true;
     }

     get authToSubmitPassword() {
        let bool = false;

        if (this.state.password.trim() !== '' && this.state.password.length > 5)
        {
           bool = true;
        }

        return bool;
     }


     joinCreativeArmy() {
       this.backToStepOne();
       this.props.quitDiscoverMyRole();

       this.props.joinCreativeArmy();

       setTimeout(() => {
         window.scrollTo(0, 0);
       }, 200);

     }




   render() {

     const textInputSize = '1rem';






    return (
         <div>




                <ParallaxProvider>




                          <div style={{position: 'fixed', zIndex: 9999999, top: 0, left: 0, width: viewportWidth+'px'}}>

                                      {this.state.errorStatus === 'connecting' &&
                                       <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #257807, #5a7509)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                          <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                             <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('All_set')}</Text>
                                          </View>
                                       </div>
                                     }


                                     {this.state.errorStatus === 'no_request' &&
                                     <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #CA1C01, #BB1603)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                        <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                           <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('no_request')}</Text>
                                        </View>
                                     </div>
                                    }


                                     {this.state.errorStatus === 'code_verified' &&
                                      <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #257807, #5a7509)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                         <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                            <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('code_successfully_verified')}</Text>
                                         </View>
                                      </div>
                                    }


                                     {this.state.errorStatus === 'has_access' &&
                                      <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #257807, #5a7509)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                         <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                            <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('You_already_have_access')}</Text>
                                         </View>
                                      </div>
                                    }


                                     {this.state.errorStatus === 'code_incorrect' &&
                                      <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #CA1C01, #BB1603)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                         <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                            <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('code_incorrect')}</Text>
                                         </View>
                                      </div>
                                    }


                                    {this.state.errorStatus === 'code_used' &&
                                     <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #CA1C01, #BB1603)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                        <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                           <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('code_used')}</Text>
                                        </View>
                                      </div>
                                    }


                                    {this.state.errorStatus === 'code_expired' &&
                                     <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #CA1C01, #BB1603)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                        <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                           <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('code_expired')}</Text>
                                        </View>
                                      </div>
                                    }


                                      {this.state.errorStatus === 'code_both' &&
                                       <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #257807, #5a7509)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                          <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                             <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('access_code_both')}</Text>
                                          </View>
                                       </div>
                                     }

                                     {this.state.errorStatus === 'code_email' &&
                                      <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #257807, #5a7509)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                         <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                            <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('access_code_email')}</Text>
                                         </View>
                                      </div>
                                    }

                                    {this.state.errorStatus === 'code_phone' &&
                                     <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #257807, #5a7509)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                        <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                           <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('access_code_phone')}</Text>
                                        </View>
                                     </div>
                                   }

                                     {this.state.errorStatus === 'error' &&
                                      <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #CA1C01, #BB1603)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                         <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                            <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('access_error_no_match')}</Text>
                                         </View>
                                      </div>
                                    }

                                     {this.state.errorStatus === 'email' &&
                                      <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #CA1C01, #BB1603)', width: '100%', height: '60px', fontSize: titleFontSize17+'px'}}>
                                         <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                            <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('email_bad_format')}</Text>
                                         </View>
                                      </div>
                                    }


                                      {this.state.errorStatus === 'phone' &&
                                        <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #CA1C01, #BB1603)', width: '100%', height: '60px', fontSize: titleFontSize17+'px', lineHeight: '60px'}}>
                                          <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                             <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{i18n.t('phone_bad_format')}</Text>
                                          </View>
                                        </div>
                                      }

                                      {this.state.errorStatus === 'internet' &&
                                       <div className="buttonWhiteText" style={{borderRadius: 0, background: 'linear-gradient(to right, #CA1C01, #BB1603)', width: '100%', height: '60px', fontSize: titleFontSize16+'px', lineHeight: '60px'}}>
                                          <View style={{width: '100%', height: '60px', alignSelf: 'center', justifyContent: 'center'}}>
                                              {i18n.language == "fr" && <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{`Désolé, une erreur est survenue. Veuillez réessayez plus tard.`}</Text>}
                                               {i18n.language == "en" && <Text style={{color: '#fff', fontSize: titleFontSize17+'px', textAlign: 'center'}}>{`Sorry, an error occurred. Please try again late.`}</Text>}
                                          </View>
                                      </div>
                                    }

                          </div>




                          <div ref={this.formContainerRef} style={{backgroundColor: '#fff', width: this.state.viewportWidth+'px'}}>


                                   <div style={{clear: 'both', height: '75px'}}/>


                                    {/* ====================================   TITRE  ==================================== */}

                                   {this.state.editProfileStep !== 2 && this.state.editProfileStep !== 3 && this.state.editProfileStep !== 4 && this.state.editProfileStep !== 5 &&
                                     <div className="page-title-phone"
                                         style={{width: this.state.viewportWidth*0.94+'px',
                                                 margin:'auto',  paddingBottom: '5px', textAlign: 'center', fontWeight: 'bold', color: '#111', fontWeight: 'bold'}}>
                                         <div>DÉCOUVRIR MA PLACE</div>
                                         <div className="page-subsubtitle-phone">DANS LA NOUVELLE INDUSTRIE NARRATIVE</div>
                                     </div>
                                   }
                                   {this.state.editProfileStep === 3 &&
                                     <div className="page-title-phone"
                                         style={{width: this.state.viewportWidth*0.94+'px',
                                                 margin:'auto',  paddingBottom: '5px', textAlign: 'center', fontWeight: 'bold', color: 'green', fontWeight: 'bold'}}>
                                         <div>Envoyé avec succès!</div>
                                     </div>
                                   }

                                   {this.state.editProfileStep === 4 &&
                                     <div className="page-title-phone"
                                         style={{width: this.state.viewportWidth*0.94+'px',
                                                 margin:'auto',  paddingBottom: '5px', textAlign: 'center', fontWeight: 'bold', color: '#e86e15', fontWeight: 'bold'}}>
                                         <div>Déjà en cours de traitement.</div>
                                     </div>
                                   }

                                   <div style={{clear: 'both', height: '40px'}}/>


                                   {this.state.editProfileStep === 4 &&
                                      <div style={{height: '80vh', width: this.state.viewportWidth*0.9+'px', margin: 'auto'}}>
                                            <View style={{width: '100%', height: '60vh', justifyContent: 'center', alignSelf: 'center'}}>
                                                 <View style={{width: '100%', alignSelf: 'center'}}>

                                                    <Image source={{uri: '/img/pending_icon.png'}} style={{marginTop: '-80px', width: 70, height: 70, alignSelf: 'center'}}/>

                                                    {i18n.language == 'en' && <Text style={{fontSize: '1.2rem', lineHeight: '1.5rem', marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>Your request was successfully submitted.</Text>}
                                                    {i18n.language == 'fr' && <Text style={{fontSize: '1.2rem', lineHeight: '1.5rem',  marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`Nous avons bien reçu votre première demande, actuellement en cours de traitement par notre équipe.`}</Text>}


                                                     {i18n.language == 'en' && <Text style={{fontSize: '1.1rem', lineHeight: '1.3rem',  marginTop: 20, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>A dedicated talent consultant will get back to you shortly.</Text>}
                                                     {i18n.language == 'fr' && <Text style={{fontSize: '1.1rem', lineHeight: '1.3rem',  marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`Inutile de soumettre une nouvelle fois: nous reviendrons vers vous très bientôt.`}</Text>}

                                                     {i18n.language == 'fr' && <Text style={{fontSize: '1.1rem', lineHeight: '1.3rem',  marginTop: 20, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`Merci pour votre patience et pour votre volonté de rejoindre l'Armée Créarive.`}</Text>}

                                                  </View>
                                              </View>
                                      </div>
                                   }


                                   {this.state.editProfileStep === 3 &&
                                      <div style={{height: '80vh', width: this.state.viewportWidth*0.9+'px', margin: 'auto'}}>
                                            <View style={{width: '100%', height: '60vh', justifyContent: 'center', alignSelf: 'center'}}>
                                                 <View style={{width: '100%', alignSelf: 'center'}}>

                                                    <Image source={{uri: '/img/yes_icon_transp.png'}} style={{marginTop: '-80px', width: 70, height: 70, alignSelf: 'center'}}/>

                                                    {i18n.language == 'en' && <Text style={{fontSize: '1.2rem', lineHeight: '1.5rem', marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>Your request was successfully submitted.</Text>}
                                                    {i18n.language == 'fr' && <Text style={{fontSize: '1.2rem', lineHeight: '1.5rem',  marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`Merci pour votre engagement.`}</Text>}


                                                     {i18n.language == 'en' && <Text style={{fontSize: '1.1rem', lineHeight: '1.3rem',  marginTop: 20, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>A dedicated talent consultant will get back to you shortly.</Text>}
                                                     {i18n.language == 'fr' && <Text style={{fontSize: '1.1rem', lineHeight: '1.3rem',  marginTop: 40, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`Notre équipe vous contactera prochainement pour échanger et explorer ensemble la meilleure manière de contribuer au processus < Re > RDC.`}</Text>}

                                                     {i18n.language == 'fr' && <Text style={{fontSize: '1.1rem', lineHeight: '1.3rem',  marginTop: 20, color: '#111', textAlign: 'center', fontFamily: 'Mohave'}}>{`En attendant, assurez-vous d’avoir consulté les principes directeurs afin de rester aligné(e) avec la vision du mouvement.`}</Text>}

                                                  </View>
                                              </View>
                                      </div>
                                   }





                                  {this.state.editProfileStep === 5 &&
                                    <div style={{width: (this.state.viewportWidth-40)+'px', margin: 'auto'}}>
                                       <View style={{width: (this.state.viewportWidth-40)+'px', minHeight: (this.state.viewportHeight-190)+'px', alignItems: 'center'}}>
                                            <div style={{width: '100%'}}>


                                                      <div style={{fontSize: titleFontSize30+'px', fontWeight: 'bold', color: '#111', textAlign: 'center'}}>Vous avez déjà accès à l’Espace des Créatifs</div>


                                                      <div style={{fontSize: titleFontSize20+'px', color: '#333', textAlign: 'center', marginTop: '30px'}}>
                                                         <a href="https://connect.debyoo.com" target="_blank">Cliquez ici pour accédez à votre espace sur Debyoo Connect →</a>
                                                      </div>



                                            </div>
                                      </View>
                                    </div>
                                  }


                                  {this.state.editProfileStep === 2 &&
                                    <div style={{width: (this.state.viewportWidth-40)+'px', margin: 'auto'}}>
                                       <View style={{width: (this.state.viewportWidth-40)+'px', minHeight: (this.state.viewportHeight-190)+'px', alignItems: 'center', justifyContent: 'center'}}>
                                            <div style={{width: '100%'}}>


                                                      <div>
                                                          <div style={{fontSize: titleFontSize20+'px', fontWeight: 'bold', color: '#111', textAlign: 'center'}}>{i18n.t('Enter_the_code_you_received')}</div>
                                                       </div>


                                                       <div style={{width: '306px', margin: 'auto', marginTop: '30px'}}>


                                                                <div style={{ display: "flex", gap: "10px", justifyContent: 'center', alignItems: 'center'}}>
                                                                   {this.state.code.map((digit, index) => (
                                                                     <input
                                                                       key={index}
                                                                       type="text"
                                                                       maxLength="1"
                                                                       value={digit}
                                                                       onChange={(e) => this.handleChange(index, e)}
                                                                       onBlur={() => this.handleBlur(index)}
                                                                       onKeyDown={(e) => this.handleKeyDown(index, e)}
                                                                       ref={(ref) => (this.inputs[index] = ref)}
                                                                       style={{
                                                                         width: "40px",
                                                                         height: "70px",
                                                                         lineHeight: "70px",
                                                                         textAlign: "center",
                                                                         fontSize: titleFontSize+'px',
                                                                         border: "1px solid #999",
                                                                         borderRadius: "6px"
                                                                       }}
                                                                     />
                                                                   ))}
                                                                 </div>


                                                                 {!this.state.processing &&
                                                                   <div className="buttonWhiteText" style={{visibility: 'hidden', background: 'transparent', width: '320px', margin: 'auto', marginTop: '20px', fontFamily: 'Roboto'}}>
                                                                     <div style={{width: '18px', height: '50px', margin: 'auto', textAlign: 'center'}}>
                                                                       <View style={{width: 18,height: 50, justifyContent: 'center'}}><ActivityIndicator  animating={true} color="#0b49ff" /></View>
                                                                     </div>
                                                                   </div>
                                                                 }
                                                                 {this.state.processing &&
                                                                   <div className="buttonWhiteText" style={{background: 'transparent', width: '320px', margin: 'auto', marginTop: '20px', fontFamily: 'Roboto'}}>
                                                                     <div style={{width: '18px', height: '50px', margin: 'auto', textAlign: 'center'}}>
                                                                       <View style={{width: 18,height: 50, justifyContent: 'center'}}><ActivityIndicator  animating={true} color="#0b49ff" /></View>
                                                                     </div>
                                                                   </div>
                                                                 }


                                                       </div>


                                                     {!this.state.processing &&
                                                       <div style={{textAlign:'center', marginTop: '20px', fontSize: titleFontSize18+'px'}}>
                                                            <div>{i18n.t('Didnt_receive_the_code')}</div>
                                                            <div><a href={void(0)} onClick={this.resendCode.bind(this)} style={{cursor: 'pointer', fontSize: titleFontSize18+'px'}}> {i18n.t('Resend_the_code')} <span style={{paddingTop: '100px', fontSize: titleFontSize+'px'}}>&#8634;</span></a></div>
                                                       </div>
                                                     }

                                              </div>

                                        </View>
                                     </div>
                                  }




                                  {this.state.editProfileStep === 1 &&
                                    <div style={{width: (this.state.viewportWidth-40)+'px', margin: 'auto'}}>
                                       <View style={{width: (this.state.viewportWidth-40)+'px', minHeight: (this.state.viewportHeight-190)+'px', alignItems: 'center'}}>
                                            <div style={{width: '100%'}}>



                                                {this.state.errorStatus !== 'no_request' &&
                                                   <div style={{width: '100%'}}>

                                                                {i18n.language == "fr" &&
                                                                   <div>
                                                                     <div style={{fontSize: titleFontSize30+'px', fontWeight: 'bold', color: '#111', textAlign: 'center'}}>Accéder à mon Espace Créatif (DConnect)</div>

                                                                    {this.state.viewportHeight > 700 &&
                                                                    <div>
                                                                       <div style={{fontSize: titleFontSize20+'px', color: '#111', textAlign: 'center', marginTop: '30px'}}>{`Vous avez déjà rejoint l'Armée Créative ?`}</div>
                                                                       <div style={{fontSize: titleFontSize17+'px', color: '#333', textAlign: 'center', marginTop: '10px'}}>{`L’Espace Créatif (DConnect) est réservé uniquement aux personnes inscriptes à l’Armée Créative. Pour y accéder, entrez le téléphone et l’email utilisés lors de votre inscription à l’Armée Créative. Vous recevrez un code par SMS et/ou email pour activer votre accès.`}</div>

                                                                     </div>
                                                                   }
                                                                  </div>
                                                                }
                                                                {i18n.language == "en" &&
                                                                   <div>
                                                                     <div style={{fontSize: titleFontSize30+'px', fontWeight: 'bold', color: '#111', textAlign: 'center'}}>Enter the participants’ area</div>

                                                                     <div style={{fontSize: titleFontSize20+'px', color: '#111', textAlign: 'center', marginTop: '30px'}}>{`Did you attend the event?`}</div>
                                                                     <div style={{fontSize: titleFontSize17+'px', color: '#333', textAlign: 'center', marginTop: '10px'}}>{`The participants’ area is reserved exclusively for those who were present.`}</div>
                                                                     <div style={{fontSize: titleFontSize17+'px', color: '#333', textAlign: 'center'}}>{`To access it, enter the phone number and email you used during your registration or attendance.`}</div>
                                                                     <div style={{fontSize: titleFontSize17+'px', color: '#333', textAlign: 'center'}}>{`You will receive a code by SMS and/or email to activate your access.`}</div>
                                                                  </div>
                                                                }



                                                                  <div style={{width: '306px', margin: 'auto', marginTop: '30px'}}>

                                                                         <form onSubmit={this.onSubmit} noValidate="novalidate" style={{}}>


                                                                            <div style={{position: 'relative', width: '306px', margin: 'auto', display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                                                               <div style={{width: '80px', lineHeight: '50px', fontSize: titleFontSize19+'px', color: '#111', textAlign: 'center',
                                                                                            borderTopLeftRadius: '6px', borderTop: '1px solid #111', borderLeft: '1px solid #111'}}>
                                                                                 {`+243`}
                                                                               </div>
                                                                               <div style={{width: '226px'}}>
                                                                                   <input className="basic_ti_top" name="phone" placeholder={'Téléphone'} onChange={this.handleChangePhone}  value={this.state.phone} type="tel"
                                                                                       style={{width: '226px', borderTopLeftRadius: '0px', borderLeft: '1px solid #ccc', padding: '6px', fontSize: titleFontSize19+'px'}}
                                                                                       autoCapitalize="off" autoComplete="off" autoCorrect="off"/>
                                                                                </div>
                                                                            </div>



                                                                            <div style={{position: 'relative', width: '306px', margin: 'auto',}}>
                                                                              <input  className="basic_ti_bottom" name="email" placeholder={'Email'} onChange={this.handleChangeEmail} value={this.state.email} type="email"
                                                                                   style={{width: '306px', padding: '6px', borderTop: '1px solid #ccc', fontSize: titleFontSize19+'px'}}
                                                                                   autoCapitalize="off" autoComplete="off" autoCorrect="off"/>
                                                                            </div>



                                                                            {!this.state.processing && this.authToSubmit &&
                                                                              <div style={{position: 'relative', width: '318px', margin: 'auto', backgroundColor: 'yellow', marginTop: '10px'}}>
                                                                                  <button style={{width: '100%', background: 'rgba(0,0,0,0)', border: 'none', padding: 0}}>
                                                                                   <div className="buttonWhiteText2"
                                                                                         style={{background: 'linear-gradient(to right, #9f07b3, #c9089c)', width: '100%', border: '1px solid #999',
                                                                                                 fontSize: titleFontSize17+'px', color: '#fff'}}>
                                                                                     {i18n.t('Receive_my_access_code')}
                                                                                   </div>
                                                                                 </button>
                                                                             </div>
                                                                           }


                                                                           {!this.state.processing && !this.authToSubmit &&
                                                                             <div style={{opacity: 0.3, position: 'relative', width: '318px', margin: 'auto', backgroundColor: 'yellow', marginTop: '10px'}}>
                                                                                 <button style={{width: '100%', background: 'rgba(0,0,0,0)', border: 'none', padding: 0}}>
                                                                                  <div className="buttonWhiteText2"
                                                                                        style={{background: 'linear-gradient(to right, #9f07b3, #c9089c)', width: '100%', border: '1px solid #999',
                                                                                                fontSize: titleFontSize17+'px', color: '#fff'}}>
                                                                                    {i18n.t('Receive_my_access_code')}
                                                                                  </div>
                                                                                </button>
                                                                            </div>
                                                                          }


                                                                         </form>




                                                                         {this.state.processing &&
                                                                           <div className="buttonWhiteText2" style={{background: 'linear-gradient(to right, #9f07b3, #c9089c)', width: '320px', margin: 'auto', marginTop: '10px', border: '1px solid #999', fontFamily: 'Roboto'}}>
                                                                             <div style={{width: '18px', height: '50px', margin: 'auto', textAlign: 'center'}}>
                                                                               <View style={{width: 18,height: 50, justifyContent: 'center'}}><ActivityIndicator  animating={true} color="#fff" /></View>
                                                                             </div>
                                                                           </div>
                                                                         }


                                                                 </div>

                                                            </div>
                                                           }


                                                           <div style={{marginTop: '50px'}}>

                                                             <div style={{fontSize: this.state.errorStatus !== 'no_request' ? titleFontSize20+'px':titleFontSize30+'px', color: '#111', textAlign: 'center'}}>{`Vous n’avez pas encore rejoint l’Armée Créative ?`}</div>
                                                             <div onClick={this.joinCreativeArmy.bind(this)} style={{fontSize: this.state.errorStatus !== 'no_request' ? titleFontSize20+'px':titleFontSize30+'px', cursor: 'pointer', color: '#0b58db', textAlign: 'center', marginTop: '5px'}}>{`→ Rejoindre maintenant`}</div>
                                                          </div>

                                              </div>

                                        </View>
                                     </div>
                                    }



                      </div>




                        <div style={{clear: 'both', height: '40px'}}/>


              </ParallaxProvider>

     </div>
    )
  }
}


const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: '52px',      // set your desired height
    height: '52px',         // optional: forces the height
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: '52px',
    padding: '0 8px',
  }),
  input: (provided) => ({
    ...provided,
    margin: '0px',
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: '52px',
  }),
};




  export default OpenDiscoverMyRoleMobile;
